<template>

    <div>

        <b-row>
        
            <photo-book-layout-template :number="1" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="2" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="3" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="4" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>


        <b-row>
        
            <photo-book-layout-template :number="5" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="6" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="7" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="8" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>

        <b-row>
            
            <photo-book-layout-template :number="9" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="10" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="11" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="12" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>

        <b-row>
            
            <photo-book-layout-template :number="13" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="14" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="15" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="16" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>

        <b-row>
            
            <photo-book-layout-template :number="17" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="18" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="19" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>
            <photo-book-layout-template :number="20" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>

        <b-row>
            
            <photo-book-layout-template :number="21" @layoutselected="layoutSelected" @layoutdeselected="layoutDeselected"></photo-book-layout-template>


        </b-row>
    </div>
</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'

import PhotoBookLayoutTemplate from "./PhotoBookLayoutTemplate";

export default {
    name: "photo-book-layout-template-selection",
    components: {
        Modal,
        BaseAlert,
        PhotoBookLayoutTemplate,
    },
    props: {
        image: '',
    },
    data() {
        return {
            loading: false,
            selected_layouts: [],
        };
    },
    methods: {
        loadSelectedLayouts(){
            //this.selected_layouts = this.currentPhotoBook.selected_book_layouts.split(",");
            console.log("Loading layouts -> "+this.selected_layouts);

            this.currentPhotoBook.selected_book_layouts.split(",").forEach((value, index) => {
               // this.$children[value].select();
                this.$children[parseInt(value)-1].toggleSelected();
                console.log("selecting -> "+parseInt(value)-1);
            });
        },
        layoutSelected(num){
            //console.log("Layout selected -> "+num);
            //console.log(this.selected_layouts);
            if(this.selected_layouts.length >= 3 ){
              //  console.log("No furhter sleesction possible..... deselecting layout...");
              //  console.log(this);
              //  console.log(this.$children[num-1]);
                this.$children[num-1].deselect();
                //this.$children[0].deselect();
            }
            else{
                if(!this.selected_layouts.includes(num)){
                    this.selected_layouts.push(num);
                }
            }  


            //console.log("Layouts after altering -> "+this.selected_layouts);
            this.currentPhotoBook.selected_book_layouts = this.selected_layouts.toString();
            
        },
        layoutDeselected(num){
            // console.log("Layout deselected -> "+num);
            if(this.selected_layouts.includes(num)){
                let pos = this.selected_layouts.indexOf(num) ; //find((element,index) => element == num);
                // console.log("ELEM is at pos: "+pos);
                this.$delete(this.selected_layouts, pos);
                    //this.selected_layouts.push(num);
                }

                // console.log("Layouts after altering -> "+this.selected_layouts);
                this.currentPhotoBook.selected_book_layouts = this.selected_layouts;
        },
        retrievePhotoBookImage() {
            console.log("the one image");
            console.log(this.image);
            console.log("the one image");
            return this.$image_host+"/"+this.image.image.medium.url; 
            this.loading = true;
            let query = {};
            query["imgid"] = this.image.id;
            this.$api.getPhotoBookImage(this.image.imageable_id, this.image.id)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return 'http://0.0.0.0:8000/'+this.photo_book_image.image.medium.url; 
                });      
        },
    },
    computed: {
        ...mapGetters({ 
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
         }),
    },
    mounted() {
        console.log(this.image);
        this.loadSelectedLayouts();
    },
};
</script>